<template>
  <div class="list-table">
    <template v-if="property === null">
      <div class="no-data">物件を検索してください。</div>
    </template>

    <template v-else-if="property.length === 0">
      <div class="no-data">物件データが存在しませんでした。</div>
    </template>

    <div class="table-wrap" @scroll.passive="updatePosition" ref="scrollBox">
      <template v-for="(item, idx) in property">
        <div class="table-inner" :key="idx">
          <table
            class="table table-property table-property--color"
            :class="{
              'is-active': checkIsActive(item.id),
              'is-f_tmp_save': item.f_tmp_save,
              'is-f_sale_state_sold': item._f_sale_state_sold,
              'is-f_sale_state_stop': item._f_sale_state_stop,
              'is-f_disable_publish_to_net': item._f_disable_publish_to_net,
            }"
            :style="{ fontSize: `${fontSize}px` }"
            @contextmenu.prevent="$refs.menu.open($event, item)"
            @click="onClickTable(item.id)"
            ref="tableProperty"
          >
            <tbody>
              <!-- 1行目 -->
              <tr class="table-property__item">
                <!-- ★ -->
                <ListTableCellListStar
                  :id="item.id"
                  :star.sync="item.list_star"
                  :updated-at.sync="item._updated_at"
                  :width="tableColWidth.col1"
                />

                <template v-for="columnItem in column">
                  <!-- 物件ID -->
                  <!-- 物件管理番号 -->
                  <!-- 登録店舗 -->
                  <!-- 自社担当者 -->
                  <td
                    v-if="columnItem.column_id === 1 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col2}px` }"
                  >
                    <div>{{ formatText(item.id) }}</div>
                    <div>{{ formatText(item.control_no) }}</div>
                    <div>{{ formatText(item._create_shop_name) }}</div>
                    <div>{{ formatText(item._charge_user_name) }}</div>
                  </td>
                  <!-- 外観・間取り -->
                  <td
                    v-if="columnItem.column_id === 2 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col3}px` }"
                  >
                    <div style="display: flex; align-items: center; justify-content: space-evenly;">
                      <div
                        v-if="item._exterior_image_path !== ''"
                        style="display: inline-block;"
                        :style="{
                          width: thumbnailSize.width + 'px',
                          height: thumbnailSize.height + 'px',
                        }"
                        @click.stop="onClickImageModal(item._exterior_image_path, item._foor_plan_image_path)"
                      >
                        <img
                          :src="item._exterior_image_path"
                          style="object-fit: cover;"
                          :style="{
                            width: thumbnailSize.width + 'px',
                            height: thumbnailSize.height + 'px',
                          }"
                        />
                      </div>
                      <div
                        v-if="item._foor_plan_image_path !== ''"
                        style="display: inline-block;"
                        :style="{
                          width: thumbnailSize.width + 'px',
                          height: thumbnailSize.height + 'px',
                        }"
                        @click.stop="onClickImageModal(getFloorPlanImageUrl(item), item._exterior_image_path)"
                      >
                        <img
                          :src="getFloorPlanImageUrl(item)"
                          style="object-fit: cover;"
                          :style="{
                            width: thumbnailSize.width + 'px',
                            height: thumbnailSize.height + 'px',
                          }"
                        />
                      </div>
                    </div>
                  </td>
                  <!-- 種別 -->
                  <td
                    v-if="columnItem.column_id === 3 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :style="{ width: `${tableColWidth.col4}px` }"
                  >
                    <div>{{ formatText(item._b_type) }}</div>
                  </td>
                  <!-- 住所 駅・徒歩 -->
                  <td
                    v-if="columnItem.column_id === 4 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col5}px` }"
                  >
                    <div>{{ formatText(item._address_combined) }}</div>
                    <div>{{ formatText(item._station1) }}・{{ formatText(item.trans_1_station_walk_min) }}分</div>
                  </td>
                  <!-- 間取り -->
                  <td
                    v-if="columnItem.column_id === 5 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :style="{ width: `${tableColWidth.col6}px` }"
                  >
                    <div>{{ formatText(item._floor_plan) }}</div>
                  </td>
                  <!-- 価格 -->
                  <td
                    v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    :style="{ width: `${tableColWidth.col7}px` }"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">{{ formatNumber(item.b_price_low) }}万円</div>
                  </td>
                  <!-- 土地面積 -->
                  <td
                    v-if="columnItem.column_id === 7 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :style="{ width: `${tableColWidth.col8}px` }"
                  >
                    <div>
                      {{ formatNumber(item.land_area_low) }}㎡ ({{ formatNumber(item._land_area_low_tsubo) }}坪)
                    </div>
                  </td>
                  <!-- 取引態様 -->
                  <!-- 確認日 -->
                  <!-- 販売状態 -->
                  <!-- 現況 -->
                  <td
                    v-if="columnItem.column_id === 8 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col9}px` }"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">
                      <div>{{ formatText(item._transaction_form) }}</div>
                      <div>{{ formatText(item._confirm_date) }}</div>
                      <div>{{ formatText(item._sale_state) }}</div>
                      <div>{{ formatText(item._vacant_type) }}</div>
                    </div>
                  </td>
                  <!-- 権利 -->
                  <td
                    v-if="columnItem.column_id === 9 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :style="{ width: `${tableColWidth.col10}px` }"
                  >
                    <div>{{ formatText(item._right_of_site) }}</div>
                  </td>
                  <!-- 坪単価 -->
                  <td
                    v-if="columnItem.column_id === 10 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :style="{ width: `${tableColWidth.col11}px` }"
                  >
                    <div>{{ formatNumber(item._b_price_low_per_tsubo) }}万円</div>
                  </td>
                  <!-- 利回り -->
                  <td
                    v-if="columnItem.column_id === 11 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    :style="{ width: `${tableColWidth.col12}px` }"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">{{ formatNumber(item.yield) }}%</div>
                  </td>
                  <!-- クローズ情報 -->
                  <td
                    v-if="columnItem.column_id === 12 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col13}px` }"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">
                      <template v-if="item._closed_info">
                        <i-icon type="ios-checkmark-circle-outline" size="18" />
                      </template>
                      <template v-else> - </template>
                    </div>
                  </td>
                  <!-- フリータグ -->
                  <td
                    v-if="columnItem.column_id === 13 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col14}px` }"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">
                      <div v-for="n in 5" :key="`feetag${n}`" class="ellipsis">
                        <template v-if="item[`free_tag_${n}`]">
                          <i-tooltip :content="item[`free_tag_${n}`]" placement="bottom-start" max-width="200" :transfer="true">
                            {{ formatText(item[`free_tag_${n}`]) }}
                          </i-tooltip>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </div>
                    </div>
                  </td>
                  <!-- 備考 -->
                  <td
                    v-if="columnItem.column_id === 14 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col15}px` }"
                  >
                    <div class="line-clamp-5">{{ formatText(item.note) }}</div>
                  </td>
                  <!-- 作成日 更新日 -->
                  <td
                    v-if="columnItem.column_id === 15 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col16}px` }"
                  >
                    <div>{{ formatText(item._created_at) }}</div>
                    <div>{{ formatText(item._updated_at) }}</div>
                  </td>
                  <!-- 業者名 担当者・連絡先 -->
                  <td
                    v-if="columnItem.column_id === 16 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col17}px` }"
                  >
                    <div>{{ formatText(item._ea_name) }}</div>
                    <div>{{ formatText(item._ea_charge_parson) }}</div>
                  </td>
                  <!-- 画像数 -->
                  <!-- パノラマ画像数 -->
                  <td
                    v-if="columnItem.column_id === 17 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    rowspan="3"
                    :style="{ width: `${tableColWidth.col18}px` }"
                  >
                    <div>{{ formatNumber(item._total_image_count) }}枚</div>
                    <div>{{ formatNumber(item._panorama_image_count) }}枚</div>
                  </td>
                </template>
              </tr>

              <!-- 2行目 -->
              <tr class="table-property__item">
                <template v-for="columnItem in column">
                  <!-- 物件名 -->
                  <td
                    v-if="columnItem.column_id === 3 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    :class="{ own_company: item.f_own_company }"
                  >
                    <div>{{ formatText(item.b_name) }}</div>
                  </td>
                  <!-- 築年数 -->
                  <td v-if="columnItem.column_id === 5 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatText(item._build_year) }}</div>
                  </td>
                  <!-- 管理費 -->
                  <td
                    v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">{{ formatNumber(item.management_fee) }}円</div>
                  </td>
                  <!-- 建物面積 -->
                  <td v-if="columnItem.column_id === 7 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>
                      {{ formatNumber(item.total_floor_area) }}㎡ ({{ formatNumber(item._total_floor_area_tsubo) }}坪)
                    </div>
                  </td>
                  <!-- 建ぺい率 -->
                  <td v-if="columnItem.column_id === 9 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatText(item.land_coverage_ratio) }}%</div>
                  </td>
                  <!-- 用途地域 -->
                  <td v-if="columnItem.column_id === 10 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatText(item._use_districts_1) }}</div>
                  </td>
                  <!-- 総戸数 -->
                  <td v-if="columnItem.column_id === 11 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatNumber(item.total_room_count) }}戸</div>
                  </td>
                </template>
              </tr>

              <!-- 3行目 -->
              <tr class="table-property__item">
                <template v-for="columnItem in column">
                  <!-- 階建・所在階・号室 -->
                  <td v-if="columnItem.column_id === 3 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>
                      {{ formatText(item.floor_ground) }} 階建 ・ {{ formatText(item._floor) }} ・
                      {{ formatText(item.room_no) }}
                    </div>
                  </td>
                  <!-- 向き -->
                  <td v-if="columnItem.column_id === 5 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatText(item._balcony_direction) }}</div>
                  </td>
                  <!-- 修繕積立金 -->
                  <td
                    v-if="columnItem.column_id === 6 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">{{ formatNumber(item.repair_reserve_cost) }}円</div>
                  </td>
                  <!-- 専有面積 -->
                  <td v-if="columnItem.column_id === 7 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>
                      {{ formatNumber(item.exclusive_area) }}㎡ ({{ formatNumber(item._exclusive_area_tsubo) }}坪)
                    </div>
                  </td>
                  <!-- 容積率 -->
                  <td v-if="columnItem.column_id === 9 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatNumber(item.land_capacity_ratio) }}%</div>
                  </td>
                  <!-- 都市計画 -->
                  <td v-if="columnItem.column_id === 10 && columnItem.f_display === 1" :key="columnItem.column_id">
                    <div>{{ formatText(item._city_planning) }}</div>
                  </td>
                  <!-- 満室時年収・月収 -->
                  <td
                    v-if="columnItem.column_id === 11 && columnItem.f_display === 1"
                    :key="columnItem.column_id"
                    class="col_edit"
                    @click.stop="onClickOpenModalQuickEdit(item)"
                  >
                    <div class="edit_cell">
                      {{ formatNumber(item.income_price) }}万円・{{ formatNumber(item._income_price_per_month) }}万円
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <ListTableConvert
            :id="item.id"
            :convert.sync="item.convert"
            :load-convert.sync="item.load_convert"
            :font-size.sync="fontSize"
          />
        </div>
      </template>
    </div>
    <!-- 右クリックメニュー -->
    <vue-context ref="menu" v-slot="{ data }" class="right-click_menu" tag="div" :lazy="true">
      <ListTableRightClickMenu :data="data" />
    </vue-context>
  </div>
</template>

<script>
// @docs https://www.npmjs.com/package/vue-context
import VueContext from 'vue-context'
import 'vue-context/dist/css/vue-context.css'
import { Icon, Tooltip } from 'view-design'
import ListTableCellListStar from '@/components/templates/ListTableCellListStar'
import ListTableConvert from '@/components/templates/ListTableConvert'
import ListTableRightClickMenu from '@/components/templates/ListTableRightClickMenu'
import Common from '@/mixins/common'
export default {
  mixins: [Common],
  components: {
    'i-icon': Icon,
    'i-tooltip': Tooltip,
    VueContext,
    ListTableCellListStar,
    ListTableConvert,
    ListTableRightClickMenu,
  },
  props: {
    property: {
      type: Array,
      default: () => [],
      required: false,
    },
    select: {
      type: Array,
      default: () => [],
      required: false,
    },
    fontSize: {
      type: Number,
      default: 12,
      requied: true,
    },
    tableColWidth: {
      type: Object,
      default: () => {},
      required: true,
    },
    tableScrollX: {
      type: Number,
      default: 0,
      requied: true,
    },
  },
  computed: {
    _select: {
      get() {
        return this.select
      },
      set(val) {
        this.$emit('update:select', val)
      },
    },
    _tableScrollX: {
      get() {
        return this.tableScrollX
      },
      set(val) {
        this.$emit('update:tableScrollX', val)
      },
    },
    // 外観・間取りのサイズ設定
    thumbnailSize() {
      let size = {
        width: 58,
        height: 58,
      }
      switch (this.fontSize) {
        case 10:
          size.width = 60
          size.height = 60
          break
        case 12:
          size.width = 70
          size.height = 70
          break
        case 14:
          size.width = 80
          size.height = 80
          break
      }
      return size
    },
    column: {
      get() {
        return this.$store.getters['Column/getColumns']
      },
      set(val) {
        this.$store.commit('Column/setColumns', val)
      },
    },
  },
  watch: {
    // スクロール値を監視して反映する
    tableScrollX(val) {
      this.$refs.scrollBox.scrollTo(val, 0)
    },
  },
  methods: {
    // テーブルコンテンツがスクロールされた時の処理
    updatePosition() {
      this._tableScrollX = this.$refs.scrollBox.scrollLeft
    },
    // アクティブ物件テーブルの判定
    checkIsActive(id) {
      let select = this.select
      return _.find(select, ['id', id])
    },
    // テーブルクリック処理
    onClickTable(id) {
      const select = this.select
      const property = this.property
      const _select = _.find(select, ['id', id])
      if (_.isUndefined(_select)) {
        // 選択配列にデータが存在しない為、追加
        const item = _.find(property, ['id', id])
        this._select.push(item)
      } else {
        // 選択配列にデータが存在する為、削除
        const item = _.reject(select, ['id', id])
        this._select = item
      }
    },
    // 画像クリック処理
    onClickImageModal(path1, path2) {
      // 画像プレビューモーダルを起動する
      const images = []
      if (path1) images.push(path1)
      if (path2) images.push(path2)
      this.$store.dispatch('ModalImagePreview/set', { images: images })
    },
    // 簡易編集モーダル 開く処理
    onClickOpenModalQuickEdit(item) {
      this.$store.dispatch('ModalPropertyQuickEdit/set', { item, type: 'investment' })
    },
    getFloorPlanImageUrl(item) {
      const url = item._foor_plan_image_path
      if (!url) return ''

      const updatedAt = item._updated_at
      if (!updatedAt) return url

      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}v=${encodeURIComponent(updatedAt)}`
    },
  },
}
</script>
<style lang="scss">
.list-table {
  .table-wrap {
    width: 100%;
    overflow-x: scroll;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .table-inner {
    transition: all ease 0.4s;
    &:hover {
      opacity: 0.7;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
    }
  }

  // 物件データ 0件時の表示定義
  .no-data {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  // 物件テーブル 基本定義
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 0;

    th,
    td {
      vertical-align: middle;
      padding: 2px;
    }
  }

  .table-property {
    border-collapse: collapse;
    overflow: hidden;

    tr {
      transition: ease 0.3s;
    }
    td {
      width: 90px;
      text-align: center;
      transition: ease 0.3s;
      &.own_company {
        color: #d00;
      }
    }

    .edit_cell {
      width: 100%;
      display: inline-block;
      transition: ease 0.3s;
      cursor: pointer;
      &:hover {
        background-color: #ffe6c0;
      }
    }

    &__item td {
      cursor: pointer;
      font-weight: bold;
      word-break: break-all;
    }

    .col_edit {
      position: relative;
    }

    // テキスト領域外の定義
    .ellipsis {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      /*text-overflow: ellipsis;*/
    }
  }
}

// 右クリックメニュー
.right-click_menu {
  padding: 10px;
}
</style>
